import { render, staticRenderFns } from "./dimensionUpload.vue?vue&type=template&id=0519adf0&"
import script from "./dimensionUpload.vue?vue&type=script&lang=js&"
export * from "./dimensionUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports